import { IStore } from "redux/store";
import { IVDMBunkerData, IVDMConsumption, IVDMDashboardStore } from "./@types";
import { jobSelectors } from "redux/_core/job";
import { getType } from "typesafe-actions";
import vdmDashboardActions from "./actions";

const vdmDashboardSelectors = {
	_getStore(store: IStore) {
		return store.app.vdmDashboard;
	},
	getVDMVesselStatus(vdmDashboardStore: IVDMDashboardStore) {
		return vdmDashboardStore.vdmVesselStatus;
	},
	getVDMActiveTab(vdmDashboardStore: IVDMDashboardStore) {
		return vdmDashboardStore.selectedVDMTab;
	},
	getVDMBunkerData(vdmDashboardStore: IVDMDashboardStore) {
		return vdmDashboardStore.bunker?.bunkerData as IVDMBunkerData;
	},
	getVDMConsumptionData(vdmDashboardStore: IVDMDashboardStore) {
		return vdmDashboardStore.consumption as Omit<IVDMConsumption, "tabType">;
	},
	getIsVDMAlertsExpanded(vdmDashboardStore: IVDMDashboardStore) {
		return vdmDashboardStore.isAlertsExpanded;
	},
	getVDMSmartAlerts(vdmDashboardStore: IVDMDashboardStore) {
		return vdmDashboardStore.smartAlerts;
	},
	getVDMFuelConsumptionDistanceCovered(vdmDashboardStore: IVDMDashboardStore) {
		return vdmDashboardStore.consumption?.fuelConsumptionDistanceCovered;
	},
	getVDMDraftSpeedImpactOnFuelConsumption(
		vdmDashboardStore: IVDMDashboardStore,
	) {
		return vdmDashboardStore.consumption?.draftSpeedImpactOnFuelConsumption;
	},
	getVDMCNRRecordsForDateRange(vdmDashboardStore: IVDMDashboardStore) {
		return vdmDashboardStore.cnrForDateRange ?? [];
	},
	getVDMDashboardSelectedDate(vdmDashboardStore: IVDMDashboardStore) {
		return vdmDashboardStore?.selectedVDMDashboardDate;
	},
	getSelectedDateCNRId(vdmDashboardStore: IVDMDashboardStore) {
		return vdmDashboardStore?.cnrIdForSelectedDate;
	},
	getVDMDashboardContent(vdmDashboardStore: IVDMDashboardStore) {
		return vdmDashboardStore?.dashboardContent;
	},
	getVDMPICDepartmentWiseAssignment(vdmDashboardStore: IVDMDashboardStore) {
		return vdmDashboardStore?.picContent;
	},
	getVDMCNRDateRangeLoad(vdmDashboardStore: IVDMDashboardStore) {
		return jobSelectors.getJobStatus(
			vdmDashboardStore,
			getType(vdmDashboardActions.commands.vdmCNRDateRangeLoad),
		);
	},
	getJobToLoadVesselVDMStatus(vdmDashboardStore: IVDMDashboardStore) {
		return jobSelectors.getJobStatus(
			vdmDashboardStore,
			getType(vdmDashboardActions.commands.vesselVDMStatusLoad),
		);
	},
	getJobToLoadVDMBunkerTab(vdmDashboardStore: IVDMDashboardStore) {
		return jobSelectors.getJobStatus(
			vdmDashboardStore,
			getType(vdmDashboardActions.commands.vdmBunkerTabLoad),
		);
	},
	getJobToLoadVDMConsumptionTab(vdmDashboardStore: IVDMDashboardStore) {
		return jobSelectors.getJobStatus(
			vdmDashboardStore,
			getType(vdmDashboardActions.commands.vdmConsumptionTabLoad),
		);
	},
	getJobToLoadVDMSmartAlerts(vdmDashboardStore: IVDMDashboardStore) {
		return jobSelectors.getJobStatus(
			vdmDashboardStore,
			getType(vdmDashboardActions.commands.vdmSmartAlertsLoad),
		);
	},
	getJobToLoadFuelConsumptionDistanceCovered(
		vdmDashboardStore: IVDMDashboardStore,
	) {
		return jobSelectors.getJobStatus(
			vdmDashboardStore,
			getType(
				vdmDashboardActions.commands.vdmFuelConsumptionDistanceCoveredLoad,
			),
		);
	},
	getJobToLoadDraftSpeedImpactOnFuelConsumption(
		vdmDashboardStore: IVDMDashboardStore,
	) {
		return jobSelectors.getJobStatus(
			vdmDashboardStore,
			getType(
				vdmDashboardActions.commands.vdmDraftSpeedImpactOnFuelConsumptionLoad,
			),
		);
	},
	getJobToLoadVDMDashboardContent(vdmDashboardStore: IVDMDashboardStore) {
		return jobSelectors.getJobStatus(
			vdmDashboardStore,
			getType(vdmDashboardActions.commands.vdmDashboardLoad),
		);
	},
	getJobToLoadVDMPICContent(vdmDashboardStore: IVDMDashboardStore) {
		return jobSelectors.getJobStatus(
			vdmDashboardStore,
			getType(vdmDashboardActions.commands.vdmPICLoad),
		);
	},
	getJobToVDMPICSave(vdmDashboardStore: IVDMDashboardStore) {
		return jobSelectors.getJobStatus(
			vdmDashboardStore,
			getType(vdmDashboardActions.commands.vdmPICSave),
		);
	},
	getJobToUploadProfilePicture(vdmDashboardStore: IVDMDashboardStore) {
		return jobSelectors.getJobStatus(
			vdmDashboardStore,
			getType(vdmDashboardActions.commands.uploadPICProfilePicture),
		);
	},
};

export default vdmDashboardSelectors;
